/**
 * Display helpers for names and emails in the Chat module.
 *
 * Kept free of React so the same rules can be exercised from a Node
 * self-check.  The UI (ChatPage / ChatUserProfileModal) owns fetching.
 */

export function chatUserName(user) {
  if (!user || typeof user !== 'object') return '';
  const fromParts = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  return (
    (user.full_name && String(user.full_name).trim())
    || fromParts
    || (user.email && String(user.email).trim())
    || ''
  );
}

/**
 * Email to render *under* the name.  Empty when the name already is the
 * email (serializer falls back to email when first/last are blank) so
 * we never print the same string twice.
 */
export function chatUserEmail(user) {
  if (!user || typeof user !== 'object') return '';
  const email = String(user.email || '').trim();
  if (!email) return '';
  const name = chatUserName(user);
  if (name && name.toLowerCase() === email.toLowerCase()) return '';
  return email;
}

export function chatUserInitials(user) {
  if (!user || typeof user !== 'object') return '?';
  const first = String(user.first_name || '').trim();
  const last = String(user.last_name || '').trim();
  const combined = (first.charAt(0) + last.charAt(0)).trim();
  if (combined) return combined.toUpperCase();
  const src = chatUserName(user) || '?';
  return src.charAt(0).toUpperCase() || '?';
}
